import React from 'react';
import { I18n } from 'aws-amplify';
import { InputRow } from 'aws-amplify-react';

export default class EnterPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorNum:"",
      errorLower:"",
      errorUpper:"",
      errorOver:"",
      errorMatch:"",
    };
    this.inputs = {};
  }
  checkPass = (name, value) => {
    // PW評価器
    let myState = this.props.passState;
    if (name === "password") {
      myState.isNumOk = value.match(/[0-9]+/) ? true : false;
      myState.isLowerOk = value.match(/([a-z])+/) ? true : false;
      myState.isUpperOk = value.match(/([A-Z])+/) ? true : false;
      myState.isOverOk = !(value.length < 8);
    }
    this.props.setPassState(myState);
    // エラーの有無をreturn
    return (myState.isNumOk && myState.isLowerOk && myState.isUpperOk && myState.isOverOk);
  }
  turnToggleDisabledWithUsername = () => {
    if (
      this.props.userName !== '' &&
      this.props.userName.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)
    ) {
      this.props.toggleDisabled(false);
    } else {
      this.props.toggleDisabled(true);
    }
  }
  turnToggleDisabledWithCode = () => {
    if (
      this.props.confirmCode !== '' &&
      !this.props.confirmCode.match(/([^0-9])+/)
    ) {
      this.props.toggleDisabled(false);
    } else {
      this.props.toggleDisabled(true);
    }
  }
  handleInputChange = (evt) => {
    let isDisabled = true;
    const { name, value } = evt.target;
    this.inputs[name] = value;
    if ((this.inputs.password === '' || this.inputs.retypepassword === '') ||
      (this.inputs.password !== this.inputs.retypepassword)) {
      this.props.setPassword('');
    }
    if (this.checkPass(name, value)) {
      isDisabled = false;
    } else {
      isDisabled = true;
    }
    // ボタンの制御
    if (
      this.inputs.hasOwnProperty("retypepassword") &&
      this.inputs.hasOwnProperty("password")
    ) {
      if (this.inputs.password === this.inputs.retypepassword && !isDisabled) {
        this.setState({errorMatch:""});
        this.props.setPassword(this.inputs.password);
        if (this.props.hasOwnProperty('userName')) {
          this.turnToggleDisabledWithUsername();
        } else if (this.props.hasOwnProperty('confirmCode')) {
          this.turnToggleDisabledWithCode();
        }
      } else if (this.inputs.password === this.inputs.retypepassword && isDisabled) {
        this.props.toggleDisabled(true);
        this.setState({errorMatch:""});
      } else {
        this.props.toggleDisabled(true);
        this.setState({errorMatch:I18n.get('Passwords do not match')});
      }
    }
  }

  render() {
    return (
      <div>
        <label className="loginLabel">{I18n.get('Password')}</label>
        <InputRow
          placeholder={I18n.get('Password')}
          theme={this.props.theme}
          type="password"
          key="password"
          name="password"
          onChange={this.handleInputChange}
        />
        <label className="loginLabel">{I18n.get('Retype Password')}</label>
        <InputRow
          placeholder={I18n.get('Retype Password')}
          theme={this.props.theme}
          type="password"
          name="retypepassword"
          onChange={this.handleInputChange}
        />
        <p className="errorText">{this.state.errorMatch}</p>
      </div>
    )
  }
}
